import { RootStateOrAny } from "react-redux";
import { AnyAction } from "redux";
import {
  LOGIN,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
  GET_CURRENT_USER,
  CLEAR_ERROR,
  VERIFY_AUTH,
  VERIFY_AUTH_SUCCESS,
  VERIFY_AUTH_FAILURE,
  SET_LAST_IDLE,
} from "./actionType";

export const initialState = {
  isLoading: false,
  authenticated: false,
  user: null,
  error: "",
  lastIdle: "",
};

const reducer = (
  state: RootStateOrAny = initialState,
  action: AnyAction
): object => {
  const { type, payload } = action;
  switch (type) {
    case LOGIN:
      return {
        ...state,
        isLoading: true,
        error: "",
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        authenticated: true,
        isLoading: false,
        user: { ...payload },
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      };
    case GET_CURRENT_USER:
      return {
        ...state,
        user: {
          ...state.user,
          accessType: payload.user?.accessType,
          accountStatus: payload.user?.accountStatus,
        },
      };
    case CLEAR_ERROR:
      return {
        ...state,
        error: "",
      };
    case VERIFY_AUTH:
      return state;
    case VERIFY_AUTH_SUCCESS:
      return {
        ...state,
        authenticated: payload,
      };
    case VERIFY_AUTH_FAILURE:
      return {
        ...state,
        authenticated: false,
        error: payload.error,
      };
    case SET_LAST_IDLE:
      return {
        ...state,
        lastIdle: payload.time,
      };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
